import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddCourseComponent } from './add-course/add-course.component';
import { CourseListComponent } from './course-list/course-list.component';
import { CourseProfileComponent } from './course-profile/course-profile.component';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';



// services

import {
  MatAutocompleteModule,
  MatToolbarModule,
  MatCardModule,
  MatInputModule,
  MatButtonModule,
  MatSidenavModule,
  MatSelectModule,
  MatDialogModule,
  MatDatepickerModule,
  MatButtonToggleModule,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatSnackBarModule,
  MatSortModule,
  MatPaginatorModule,
  MatSliderModule,
  MatStepperModule,
  MatTooltipModule
} from '@angular/material';



// internationalization
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


const routes: Routes = [
  { path: 'courses', component: CourseListComponent},
  { path: 'addcourse', component: AddCourseComponent},
  { path: 'course/:id', component: CourseProfileComponent},
]





@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild({
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
      },
  }),
  SharedModule,
  MatDatepickerModule,
  MatButtonToggleModule,
  FormsModule,
  MatAutocompleteModule,
  MatSnackBarModule,
  MatSortModule,
  MatPaginatorModule,
  MatTooltipModule,
  ],
  declarations: [AddCourseComponent, CourseListComponent, CourseProfileComponent],
  providers:[],
})
export class TrainingModule { }
